var map = {
	"./Quote_Image_Desktop.jpg": 3402,
	"./Quote_Image_Mobile.jpg": 9167,
	"./Quote_Image_Tablet.jpg": 9761,
	"./quoteMarks.svg": 2422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5621;